import Icon from '@ant-design/icons';
import FaceIcon from '../../assets/icons/authenticators/face_bio.svg?react';
import './AuthenticatorNameAndIcon.less';

const AuthenticatorNameAndIcon = () => {
  return (
    <div className="authenticator-name-and-icon">
      <Icon component={FaceIcon} />
      <span className="authenticator-name">Face</span>
    </div>
  );
};

export default AuthenticatorNameAndIcon;
